import { constants } from '../config';
// import { Rollbar } from './Rollbar';

/*
  These adapters must implement these methods:
    - log(message): logs a message that is not an error or warning.
        if you're implementing an adapter for error tracking, this kind
        of message should be ignored.
    - warn(message): similar to log, but a bit more important. You should
        also avoid tracking it on error reporting.
    - error(message): logs an error.

  NOTE: In order to provide consistent logging, these methods should be
    used with caution. Try to use the correct logging function for your case.
*/

class ProductionAdapter {
  static log() {}
  static warn() {}
  static error() {}
}

class StagingAdapter {
  constructor() {
    this.logger = console;
  }

  log(...messages) {
    this.logger.log(...messages);
  }

  warn(...messages) {
    this.logger.warn(...messages);
  }

  // NOTE: It is assumed error is a javascript error
  error(error) {
    this.logger.error(error);
    // Rollbar.error(error.message, error);
  }
}

class DevelopmentAdapter {
  constructor() {
    this.logger = console;
  }

  log(...messages) {
    this.logger.log(...messages);
  }

  warn(...messages) {
    this.logger.warn(...messages);
  }

  // NOTE: It is assumed error is a javascript error
  error(error) {
    this.logger.error(error);
  }
}

/* eslint-disable-next-line import/no-mutable-exports */
let Logger = null;
if (constants.environment.isDevelopment) {
  Logger = new DevelopmentAdapter();
} else if (constants.environment.isStaging) {
  Logger = new StagingAdapter();
} else {
  Logger = ProductionAdapter;
}

export { Logger };



// WEBPACK FOOTER //
// ./src/helpers/Logger.js